"use strict";

var _toConsumableArray = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _slicedToArray = require("E:\\MyProject\\Project\\furegame\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWorld = exports.useEngine = exports.World = exports.EngineContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var Matter = _interopRequireWildcard(require("matter-js"));

var _Renderer = require("../Renderer");

var _hooks = require("../hooks");

var _Ticker = require("../Ticker");

var _Mouse = require("./Mouse");

var _Composite = require("./Composite");

var _UI = require("../UI");

var _operators = require("rxjs/operators");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var eventNames = ['beforeAdd', 'afterAdd', 'beforeRemove', 'afterRemove', 'beforeUpdate', 'afterUpdate', 'beforeRender', 'afterRender', 'collisionStart', 'collisionActive', 'collisionEnd', 'beforeTick', 'tick', 'afterTick', 'beforeRender', 'afterRender'];
var defaultRenderOptions = {
  wireframeBackground: 'transparent',
  showPositions: true,
  showBounds: true,
  showVelocity: true,
  showCollisions: true
};
var EngineContext = (0, _react.createContext)(undefined);
exports.EngineContext = EngineContext;
EngineContext.displayName = 'World.Engine';

var World = function World(_ref) {
  var children = _ref.children,
      _ref$events = _ref.events,
      events = _ref$events === void 0 ? {} : _ref$events,
      _ref$renderDebug = _ref.renderDebug,
      renderDebug = _ref$renderDebug === void 0 ? false : _ref$renderDebug,
      definition = _objectWithoutProperties(_ref, ["children", "events", "renderDebug"]);

  var renderer = (0, _Renderer.useRenderer)();
  var ticker = (0, _Ticker.useTicker)();
  var engine = (0, _hooks.useCloseable)(function () {
    var engine = Matter.Engine.create(definition); // Matter.Engine.run(engine);

    ticker.each(function (delta) {
      return Matter.Engine.update(engine, delta);
    });
    return engine;
  }, function (engine) {
    return Matter.Engine.clear(engine);
  });
  eventNames.forEach(function (name) {
    return (0, _react.useEffect)(function () {
      var callback = events[name];
      if (callback == null) return;
      Matter.Events.on(engine, name, callback);
      return function () {
        return Matter.Events.off(engine, name, callback);
      };
    }, [events[name]]);
  }); // render debug canvas.

  (0, _react.useEffect)(function () {
    var _canvas$classList;

    if (!renderDebug) return; // eslint-disable-next-line @typescript-eslint/no-explicit-any

    var _ref2 = renderDebug === true ? {} : renderDebug,
        _ref2$classList = _ref2.classList,
        classList = _ref2$classList === void 0 ? ['UI'] : _ref2$classList,
        renderDefinition = _objectWithoutProperties(_ref2, ["classList"]);

    var renderOptions = _objectSpread({
      width: renderer.width,
      height: renderer.height
    }, defaultRenderOptions, {}, renderDefinition.options);

    var _ref3 = renderDefinition.canvas ? [renderDefinition.canvas] : function () {
      if (renderer.view.parentNode == null) return [];
      var canvas = document.createElement('canvas');
      canvas.id = 'debugRenderer';
      renderer.view.parentNode.appendChild(canvas);
      var style = canvas.style; // prevent `Matter` change the canvas style

      Object.defineProperty(canvas, 'style', {
        get: function get() {
          return {};
        }
      });
      return [canvas, style];
    }(),
        _ref4 = _slicedToArray(_ref3, 2),
        canvas = _ref4[0],
        style = _ref4[1];

    var render = Matter.Render.create(_objectSpread({}, renderDefinition, {
      canvas: canvas,
      engine: engine,
      options: renderOptions
    }));

    (_canvas$classList = canvas.classList).add.apply(_canvas$classList, _toConsumableArray(classList));

    Matter.Render.run(render);
    if (style == null) return;

    var updateStyle = function updateStyle() {
      var _renderer$view = renderer.view,
          clientWidth = _renderer$view.clientWidth,
          clientHeight = _renderer$view.clientHeight,
          offsetLeft = _renderer$view.offsetLeft,
          offsetTop = _renderer$view.offsetTop;
      style.width = "".concat(clientWidth, "px");
      style.height = "".concat(clientHeight, "px");
      style.left = "".concat(offsetLeft, "px");
      style.top = "".concat(offsetTop, "px");
    };

    var sub = (0, _UI.fromResize)(renderer.view).pipe((0, _operators.debounceTime)(100)).subscribe(function (_) {
      return updateStyle();
    });
    updateStyle();
    return function () {
      return sub.unsubscribe();
    };
  }, [engine]);
  return _react.default.createElement(EngineContext.Provider, {
    value: engine
  }, _react.default.createElement(_Composite.CompositeContext.Provider, {
    value: engine.world
  }, children));
};

exports.World = World;

var useEngine = function useEngine() {
  var engine = (0, _react.useContext)(EngineContext);
  (0, _react.useDebugValue)(engine, function (engine) {
    var g = window; // eslint-disable-line @typescript-eslint/no-explicit-any
    // for debugger

    g.Matter = Matter;
    g.engine = engine; // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-debugger

    if (useEngine.firstDebug !== false) {
      debugger;
      useEngine.firstDebug = false;
    }

    return "engine#".concat(engine.world.id);
  });
  return engine;
};

exports.useEngine = useEngine;

var useWorld = function useWorld() {
  return (useEngine() || {}).world;
};

exports.useWorld = useWorld;
World.Mouse = _Mouse.Mouse;

var useEvent = function useEvent(name, callback) {
  var engine = useEngine();
  (0, _react.useEffect)(function () {
    Matter.Events.on(engine, name, callback);
    return function () {
      return Matter.Events.off(engine, name, callback);
    };
  }, [engine]);
};

World.useEvent = useEvent;